export var LeaflyEnv;
(function (LeaflyEnv) {
    LeaflyEnv["Production"] = "prod";
    LeaflyEnv["Staging"] = "staging";
    LeaflyEnv["Dev"] = "dev";
    LeaflyEnv["LocalDev"] = "local-dev";
    LeaflyEnv["Test"] = "test";
    LeaflyEnv["CI"] = "ci";
})(LeaflyEnv || (LeaflyEnv = {}));
//# sourceMappingURL=constants.js.map